// extracted by mini-css-extract-plugin
module.exports = {"projectCardSummary":"ProjectCardSummary_projectCardSummary__30zkp"};